import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Typography } from "@material-ui/core";
import './Comments.css';

const useStyles = makeStyles((theme) => ({
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      fontSize: "11px"
    },
    large: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      fontSize: "34px",
    },
    commentName: {
      padding: "0 0 0 5px",
      lineHeight: 1,
    },
    commentNameBox: {
      display: 'flex',
      alignItems: "center",
      justifyContent: "center",
    },
    commentBox: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "3%",
    },
    commentTextBox: {
      paddingTop: "10px"
    }
}));

export default function Comments(props) {
    const classes = useStyles();
    const dashboard = useSelector((state) => state.dashboard)
    const comments = dashboard?.data?.comments
    let commentList = []
    for (const comment of comments) {
        commentList.push(
          <div className={classes.commentBox} key={comment.id}>
            <div className="comment-detail">
                <div className="comment-avatar">
                    <Avatar className={classes.small}>{comment.agent_data.first_name.charAt(0)}{comment.agent_data.last_name.charAt(0)}</Avatar>
                </div>
                <div className={classes.commentNameBox}>
                  <Typography variant="subtitle2" className={classes.commentName} style={{color: "#5A5A5A"}}>{comment.agent_data.first_name} {comment.agent_data.last_name}</Typography>
                </div>
            </div>
            <div className={classes.commentTextBox}>
              <Typography style={{wordWrap: "break-word"}} variant="subtitle1">{comment.text}</Typography>
            </div>
            <div className="time-stamp">
              <Typography variant="caption">{comment.created}</Typography>
            </div>
            <div className="border"></div>
          </div>
        )
    }
    return (
        <div className="comments-base">
                <Typography className={props.classes.body1} style={{paddingBottom: "12px"}}>Comments</Typography>
                <div className="comment-details">
                    {commentList?.length ? commentList : <Typography variant="subtitle1">No comments available yet</Typography>}
                </div>
        </div>
    );
}